import { AppConfig } from 'model/app-config';

export const config: AppConfig = {
  name: 'Avakompas',
};
